import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import dayjs from 'dayjs'

import { Form } from '../../common/form/Form'
import { Pagination } from '../dataViews/Pagination'

export const FilteredRows = ({
  setOpenFormModal,
  filterType,
  defaultData,
  envData,
  formSchema,
  modSchema,
  isUpdate,
  isRowForm,
  schema,
  currentPage,
  childFormModalOpen,
}) => {
  const [curPage, setCurPage] = React.useState(
    sessionStorage.getItem(modSchema.moduleName + 'curPageActiveGeneralHolidays')
      ? parseInt(sessionStorage.getItem(modSchema.moduleName + 'curPageActiveGeneralHolidays'))
      : 1,
  )

  const filteredData = []
  if (schema?.filterBy) {
    defaultData.filter((f) => {
      f[schema.filterBy] === schema.filterByValue && filteredData.push(f)
    })
  } else if (schema.filterBy) {
    defaultData.filter((f) => {
      f[schema.filterBy] === schema.filterByValue && filteredData.push(f)
    })
  }

  const handleCurPage = (page) => {
    sessionStorage.setItem(modSchema.moduleName + 'curPageActive', page)
    setCurPage(page)
  }

  const getDayFromDate = (date) => {
    const d = new Date(date)
    let day = d.getDay()
    day =
      day === 0
        ? 'Sunday'
        : day === 1
          ? 'Monday'
          : day === 2
            ? 'Tuesday'
            : day === 3
              ? 'Wednesday'
              : day === 4
                ? 'Thursday'
                : day === 5
                  ? 'Friday'
                  : 'Saturday'
    return day
  }

  const showStartAndEnd = (data) => {
    const dataArray = {}
    data
      .sort((a, b) => new Date(a.createdDateTime) - new Date(b.createdDateTime))
      .map((m, mI) => {
        if (mI === 0) {
          dataArray['first'] = m
        }
        if (mI === data.length - 1) {
          dataArray['last'] = m
        }
      })
    const grp = _.groupBy(data, 'academicYearHolidayName')
    const groupArr = _.values(grp)
    const arrRet = {}
    const displayVacation = (arr) => {
      arr.map((a, aI) => {
        if (aI === 0) {
          arrRet['first'] = a
        }
        if (aI === arr.length - 1) {
          arrRet['last'] = a
        }
      })
      return (
        <strong>
          {arrRet.first.academicYearHolidayName} from{' '}
          {dayjs(arrRet.first.academicYearHolidayDate).format('DD-MM-YYYY')} to{' '}
          {dayjs(arrRet.last.academicYearHolidayDate).format('DD-MM-YYYY')}
        </strong>
      )
    }

    return groupArr.map((group, groupIndex) => (
      <div className="mb-2" key={`${groupIndex}${group}`}>
        {displayVacation(group)}
      </div>
    ))
  }

  if (filterType === 'WEEKLY') {
    return (
      <>
        {filteredData <= 0 && (
          <button
            className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-float-right"
            onClick={() => childFormModalOpen(schema.create)}
          >
            <i className="ri-add-line" /> Add
          </button>
        )}
        <div className="trtui-row trtui-g-2">
          <div className="trtui-col-12">
            {`${getDayFromDate(filteredData[0]?.academicYearHolidayDate)} is weekly holiday.`}
          </div>
        </div>
      </>
    )
  } else if (filterType === 'VACATION') {
    return (
      <>
        <button
          className="trtui-btn trtui-btn-primary trtui-btn-sm trtui-float-right"
          onClick={() => childFormModalOpen(schema.create)}
        >
          <i className="ri-add-line" /> Add
        </button>
        <>{filteredData.length > 0 && showStartAndEnd(filteredData)}</>
      </>
    )
  } else if (filterType === 'GENERAL') {
    return (
      <>
        <Form
          key={`${curPage}${modSchema.moduleName}${currentPage}${
            defaultData[curPage - 1]
          }filterdupdate`}
          setOpenFormModal={setOpenFormModal}
          defaultData={filteredData[curPage - 1]}
          envData={envData}
          formSchema={formSchema}
          modSchema={modSchema}
          isUpdate={isUpdate}
          isRowForm={isRowForm}
        />
        {filteredData.length > 1 && (
          <div className="trtui-mt-3">
            <Pagination
              key={`${curPage}`}
              currentPage={curPage}
              totalCount={filteredData.length}
              siblingCount={1}
              pageSize={1}
              onPageChange={handleCurPage}
            />
          </div>
        )}
      </>
    )
  }
}

FilteredRows.propTypes = {
  setOpenFormModal: PropTypes.func,
  filterType: PropTypes.string,
  defaultData: PropTypes.object,
  envData: PropTypes.object,
  formSchema: PropTypes.object,
  modSchema: PropTypes.object,
  isUpdate: PropTypes.bool,
  isRowForm: PropTypes.bool,
  schema: PropTypes.object,
  currentPage: PropTypes.number,
  childFormModalOpen: PropTypes.func,
}
